import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

class Filter extends Component {
    _renderLetters(alphabet) {
        let render = [];

        if (alphabet.length === 0) return null;

        return (
            <div className="hidden xl:flex flex-col">
                {alphabet.map((item, index) => {
                    render.push(
                        <p
                            onClick={() => {
                                if (item === "#") this.props.onChange(null);
                                else this.props.onChange(item);
                            }}
                            className="text-pink cursor-pointer text-30 font-bold mr-10 w-30 h-30 uppercase"
                        >
                            {item}
                        </p>
                    );

                    if (
                        alphabet.length - 1 === index ||
                        (index > 0 && index % 15 === 0)
                    ) {
                        const value = render.slice();
                        render = [];
                        return (
                            <div key={index} className="flex">
                                {value}
                            </div>
                        );
                    }
                })}
            </div>
        );
    }

    _renderLettersMobile(alphabet) {
        let render = [];

        if (alphabet.length === 0) return null;

        return (
            <div className="md:hidden flex flex-col">
                {alphabet.map((item, index) => {
                    render.push(
                        <p
                            onClick={() => {
                                if (item === "#") this.props.onChange(null);
                                else this.props.onChange(item);
                            }}
                            className="text-pink cursor-pointer text-30 font-bold mr-10 w-30 h-30 uppercase"
                        >
                            {item}
                        </p>
                    );

                    if (
                        alphabet.length - 1 === index ||
                        (index > 0 && index % 6 === 0)
                    ) {
                        const value = render.slice();
                        render = [];
                        return (
                            <div key={index} className="flex">
                                {value}
                            </div>
                        );
                    }
                })}
            </div>
        );
    }

    _renderLettersTablet(alphabet) {
        let render = [];

        if (alphabet.length === 0) return null;

        return (
            <div className="hidden md:flex xl:hidden flex-col">
                {alphabet.map((item, index) => {
                    render.push(
                        <p
                            onClick={() => {
                                if (item === "#") this.props.onChange(null);
                                else this.props.onChange(item);
                            }}
                            className="text-pink cursor-pointer text-30 font-bold mr-10 w-30 h-30 uppercase"
                        >
                            {item}
                        </p>
                    );

                    if (
                        alphabet.length - 1 === index ||
                        (index > 0 && index % 10 === 0)
                    ) {
                        const value = render.slice();
                        render = [];
                        return (
                            <div key={index} className="flex">
                                {value}
                            </div>
                        );
                    }
                })}
            </div>
        );
    }

    render() {
        const { data } = this.props;

        return (
            <div>
                {this._renderLetters(data)}
                {/*this._renderLettersTablet(data)*/}
                {/*this._renderLettersMobile(data)*/}
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    locale: state.app.locale,
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(Filter);
